import React from 'react';
import { Link } from 'react-router-dom';
import { LineChartIcon, ActivityIcon, PillIcon, UsersIcon, ArrowRightIcon } from 'lucide-react';
export const ReportsPage: React.FC = () => {
  const reports = [{
    id: 'fall-risk',
    title: 'Fall Risk Assessment Report',
    description: 'Identifies residents who may be at elevated risk for falls based on their health factors.',
    icon: <ActivityIcon className="h-8 w-8 text-[#f97c6b]" data-id="element-347" />,
    path: '/report/fall-risk'
  }, {
    id: 'occupancy',
    title: 'Quarterly Occupancy Trends Report',
    description: 'Shows occupancy trends over the last quarter, including move-ins and move-outs.',
    icon: <LineChartIcon className="h-8 w-8 text-[#1f58b0]" data-id="element-348" />,
    path: '/report/occupancy'
  }, {
    id: 'medication-review',
    title: 'Medication Review Report',
    description: 'Identifies residents who need medication reviews this week, prioritized by urgency.',
    icon: <PillIcon className="h-8 w-8 text-[#f6d052]" data-id="element-349" />,
    path: '/report/medication-review'
  }, {
    id: 'staffing-ratio',
    title: 'Staff-to-Resident Ratio Comparison',
    description: 'Compares staff-to-resident ratios across all Further managed facilities.',
    icon: <UsersIcon className="h-8 w-8 text-[#255db7]" data-id="element-350" />,
    path: '/report/staffing-ratio'
  }];
  return <main className="flex-1 overflow-y-auto bg-gray-50 p-6" data-id="element-351">
      <div className="mb-6" data-id="element-352">
        <h1 className="text-2xl font-bold mb-2" data-id="element-353">Reports</h1>
        <p className="text-gray-600" data-id="element-354">
          Access detailed analytics and insights about residents, facilities,
          and operations.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-355">
        {reports.map(report => <Link key={report.id} to={report.path} className="bg-white rounded-lg shadow hover:shadow-md transition-shadow overflow-hidden" data-id="element-356">
            <div className="p-6" data-id="element-357">
              <div className="flex items-start" data-id="element-358">
                <div className="bg-gray-50 p-3 rounded-lg mr-4" data-id="element-359">
                  {report.icon}
                </div>
                <div className="flex-1" data-id="element-360">
                  <h2 className="text-lg font-semibold mb-2" data-id="element-361">{report.title}</h2>
                  <p className="text-gray-600 mb-4" data-id="element-362">{report.description}</p>
                  <div className="flex items-center text-[#1f58b0] font-medium" data-id="element-363">
                    View Report
                    <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-364" />
                  </div>
                </div>
              </div>
            </div>
          </Link>)}
      </div>
    </main>;
};